import React, { memo } from 'react';

export interface LogoProps {
  collapsed?: boolean;
  compact?: boolean;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = memo(({ collapsed, compact, onClick }) => {
  const logoHeight = collapsed ? 24 : compact ? 22 : 32;
  const logoMaxWidth = collapsed ? '40px' : compact ? '110px' : '180px';
  const logoPadding = compact ? '0 10px' : '0 24px';
  const containerHeight = compact ? '56px' : '64px';

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label="Ir para página inicial"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      style={{
        cursor: 'pointer',
        padding: logoPadding,
        display: 'flex',
        alignItems: 'center',
        height: containerHeight,
        flexShrink: 0,
      }}
    >
      <img
        src="/assets/brand/logo.png"
        alt="PePoll"
        style={{
          height: `${logoHeight}px`,
          width: 'auto',
          maxWidth: logoMaxWidth,
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </div>
  );
});
